import { createSlice } from "@reduxjs/toolkit";

export const customAccessLabel = "Custom access";

export const impersonationSlice = createSlice({
  name: "impersonation",
  initialState: {
    company: "",
    user: "",
  },
  reducers: {
    setImpersonation: (state, action) => {
      if (Object.prototype.hasOwnProperty.call(action.payload, "company")) {
        state.company = action.payload.company || "";
      }
      if (Object.prototype.hasOwnProperty.call(action.payload, "user")) {
        state.user = action.payload.user || "";
      }
    },
  },
});

export const { setImpersonation } = impersonationSlice.actions;

export default impersonationSlice.reducer;
